<template>
  <div class="jobsc_container">
    <!-- <div class="jobsc_category">
      <p  v-for="(item,index) in cate" :key='index' :class="{active: active == item}" @click="active=item" >{{item}}</p>
    </div> -->
    <div class="category_item" :class="origin" >
      <div class="item_content" :style="{width}" data-growing-container :data-growing-idx="700 + index" v-for="(item,index) in categoryList" :key='index' >
          <div class="content_img" @click='goToDetail(item.token)'><img :src="item.company_logo || item.company_logo_hr || 'https://files.wondercv.com/icon/Artboard.png'" alt=""></div>
          <div class="category-info">
            <div class="content_infos" @click='goToDetail(item.token)'>
              <!-- <p class="infos_comp" v-if="origin && origin === 'cvs'">{{ item.company_name }}</p> -->
              <p class="infos_comp">{{item.company_name}}</p>
              <p class="infos_cate">{{item.category}} <template v-if="item.category && item.city_names">|</template> <span>{{ item.city_names | cityFilter }}</span></p>
              <!-- <p class="infos_time">{{item.display_time === null ? '已开始':item.display_time }}</p> -->
            </div>
            <div class="time">
              <i class="iconfont iconshijian" style="color: #FF6644;"></i>
              <p class="infos_time">{{recruitmentTime(item.comp_recruit_info)}}</p>
            </div>
            <!-- <div class="content_coll" @click="changeLike(item.comp_recruit_info.id,item.job_is_liked)">
              <i class="iconfont iconstar" :class="{staractive: item.job_is_liked ===true}" ></i>
            </div> -->
            <!-- <div class="tags clearfix">
              <div class="tag-item fl recommend-btn" v-if="item.can_recommend">{{ item.can_recommend | recommendFilter }}</div>
              <div class="tag-item fl" v-if="item.display_time">{{ item.display_time }}</div>
              <div class="tag-item fl" v-if="item.status">{{ item.status }}</div>
              <div class="tag-item fl" v-if="!item.can_recommend && !item.display_time && !item.status">热招中</div>
            </div> -->
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import {routerTo,recruitmentTime} from '@/assets/js/util'
const moment = require('moment')

export default {
  name: 'category',
  props: {
    // 引用位置
    origin: {
      type: String,
      default: null
    },
    // 卡片宽度
    width: {
      type: String,
      default: null
    },
    // 显示卡片数量
    showCardCount: {
      type: Number,
      default: null
    },
    // 卡片列表
    cardList: {
      type: Array,
      default: null
    },
  },
  data () {
    const cate= ['最新',"热门","互联网","金融","咨询","快消","电子","房地产","其他"]
    return {
      cate:cate,
      active:"最新",
      collection:false,//收藏职位
      categoryList: []
    }
  },
  watch: {
    active (){this.getJobList()},
    cardList: {
      handler(val) {
        if (this.origin === 'cvs') {
          this.categoryList = val.slice(0, this.showCardCount)
        } else {
          this.getJobList()
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.origin === 'cvs') {
      this.categoryList = this.cardList.slice(0, this.showCardCount)
    } else {
      this.getJobList()
    }
  },
  filters: {
		jobLikeFilter(val) {
			return val ? '已关注' : '关注'
		},
		cityFilter(val) {
			if (val && val.length) {
				let cityStr = ''
				val.forEach((item, index) => {
					if (index < 2) cityStr += `${ item }、`
				})
				return val.length > 2 ? cityStr.slice(0, -1) + '等' : cityStr.slice(0, -1)
			} else {
				return '全国'
			}
		},
		recommendFilter(val) {
			return val ? '可内推' : ''
		},
    momentTime(value){
      return value ? `${moment().format('YYYY-MM-DD')} 截止` : '已开始'
    },
	},
  methods: {
    recruitmentTime,
    async getJobList() {
    api.jobs.get_recruit_list({
      page:1,
      size: 9,
      info_type: '不限',
      type: 'hot',
    }).then(res=>{
      if(res.code === 1000){
        if(res.data.top_comp_recruit_infos !== null && res.data.top_comp_recruit_infos !== 'null'){
          this.categoryList = [...res.data.top_comp_recruit_infos,...res.data.comp_recruit_infos]
        }else{
          this.categoryList = res.data.comp_recruit_infos
        }
      }
    })
    },
    //切换喜欢状态
    async changeLike(id, type) {
      if (type) {
        api.jobs.changeLike({
          type: 'dislike',
          comp_recruit_id: id
        }).then (res => {
          for (let i = 0; i < this.categoryList.length; i++) {
            if(id == this.categoryList[i].comp_recruit_info.id){
              this.categoryList[i].job_is_liked = false
            }
          }
        })
      } else {
        api.jobs.changeLike({
          type: 'like',
          comp_recruit_id: id
        }).then (res => {
          for (let i = 0; i < this.categoryList.length; i++) {
            if(id == this.categoryList[i].comp_recruit_info.id){
              if(res.code === 1000) {
                this.categoryList[i].job_is_liked = true
              }
            }
          }
        })
      }

    },
    //跳转详情页
    goToDetail (token) {
      routerTo(`/comp_recruit_infos/${token}`,'_blank')
    }
  }

}
</script>

<style lang="scss" scoped>
.jobsc_container {
  width: 100%;
  .jobsc_category {
    margin: 24px 0;
    width: 100%;
    height: 34px;
    p {
      display: inline-block;
      margin-right: 16px;
      width: 80px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      font-size: 14px;
      color: #404040;
      border-radius: 4px;
      background-color: #fff;
      cursor: pointer;
    }
    .active {
      color: #fff;
      background-color: #FF6644;
    }
  }
  .category_item {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    column-gap: 16px;
    width: 100%;
    height: 100%;

    &.cvs {
      box-sizing: border-box;

      .item_content {
        height: auto;
        margin-bottom: 20px;
        padding: 20px 20px 0 20px;
        // border: 1px solid #ECECEC;
        transition: all 0.3s;

        &:hover {
          border: none;
          box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.1);
          transform: translateY(-5px);
        }

        .content_infos {
          margin-top: 0px;
          padding-bottom: 0px;
          border: 0;
          .infos_cate{
            color: rgba($color: #000000, $alpha: 0.6);
          }
        }

        .content_img {
          width: 50px;
          height: 50px;
          img{
            border: 0;
          }
        }

        .infos_comp {
          font-size: 16px !important;
          line-height: 22px !important;
        }
        
        .infos_cate {
          font-size: 14px !important;
          line-height: 20px;
          height: 20px !important;
        }

        .time {
          margin-bottom: 20px;
          height: 32px;
          line-height: 32px;
          border-radius: 16px;
          background: #F5F5F7;
          i{
            margin-left: 12px;
          }
          p{
            color: #000;
          }
        }
      }

    }

    .item_content {
      display: flex;
      margin-bottom: 16px;
      width: 388px;
      height: 144px;
      background-color: #fff;
      cursor: pointer;
      padding: 24px 24px 0 24px;
      box-sizing: border-box;
      border-radius: 8px;
      .content_img {
        width: 60px;
        height: 60px;
        margin-right: 12px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 4px;
          border: 1px solid #f9f9f9;
        }
      }
      .category-info{
        flex: 1;
      }
      .content_infos {
        border-bottom: 1px dashed #ECECEC;
        padding-bottom: 12px;
        margin-bottom: 10px;
        margin-top: 10px;
        .infos_comp{
          max-width: 260px;
          height: 20px;
          line-height: 20px;
          font-size:18px;
          font-weight:500;
          color:rgba(64,64,64,1);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .infos_cate {
          margin: 8px 0;
          height:14px;
          font-size:14px;
          color:#9C9C9C;
        }
        .infos_time {
          font-size:12px;
          color:#404040;
        }
      }
      .content_coll {
        position: relative;
        width: 16px;
        height: 60px;
        i {
           font-size: 16px;
           color:#D3D3D3;
        }
        .staractive {
           color: #FFBA00;
        }
      }
      .tags{
        height: 24px;
        overflow: hidden;
        .tag-item{
          padding: 0 10px;
          line-height: 24px;
          color: #9c9c9c;
          font-size: 12px;
          margin-right: 6px;
          background: #F9F9F9;
          border-radius: 12px;
          &.recommend-btn{
            background: #FFF6F4;
            color: #FF6644;
          }
        }
      }
      &:hover{
        box-shadow: 0px 2px 28px 0px rgba(10,44,156, .1);
        .infos_comp{
          color: #FF6644 !important;
        }
      }
    }
  }
  .container_page {
    position: absolute;
    top: 1300px;
    left: 0;
    width: 100%;
    height: 50px;
  }
}
.time {
  display: flex;
  background: #f9f9f9;
  height: 28px;
  border-radius: 14px;
  line-height: 28px;
  i {
    margin-right: 8px;
    margin-left: 10px;
  }
  p {
    font-size: 14px;
    color: #404040;
  }
}
</style>
